import { faUserClock } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { makeStyles } from '@material-ui/core/styles';
import RoomIcon from '@material-ui/icons/Room';
import headlinerStyle from 'assets/jss/material-kit-pro-react/views/landingPageSections/headlinerStyle.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import { graphql, Link, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';

const useStyles = makeStyles(headlinerStyle);

export default function SectionHeadliner() {
  const {
    chilimaniaLogo,
    chilimaniaHeadlinerImage,
    countryEdgeLogo,
    countryEdgeHeadlinerImage,
    headlinerBackground,
    placeholderImage,
  } = useStaticQuery(graphql`
    query getHeadlinerImages {
      chilimaniaLogo: file(
        relativePath: { eq: "logos/chilimania-logo-transparent-white.png" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      chilimaniaHeadlinerImage: file(
        relativePath: { eq: "headliners/2026/def-leggend-headliner.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      countryEdgeLogo: file(
        relativePath: { eq: "logos/country-edge-logo.png" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      countryEdgeHeadlinerImage: file(
        relativePath: { eq: "headliners/2026/dylan-scott-headliner.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      headlinerBackground: file(
        relativePath: { eq: "backgrounds/stage-headliner.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      placeholderImage: file(
        relativePath: { eq: "headliners/headliner-placeholder-2.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
    }
  `);
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <GatsbyImage
        className={classes.backgroundImage}
        image={headlinerBackground.childImageSharp.gatsbyImageData}
        alt="Event Photo"
      />
      <div className={classes.backgroundImageText}>
        <div className={classes.container}>
          <h2 className={classes.headlinerTitle}>Headliners</h2>
          <GridContainer
            className={classes.headlinerContainer}
            alignItems="flex-start"
          >
            <GridItem xs={12} sm={8} md={6} className={classes.headlinerItem}>
              <div className={classes.logoContainer}>
                <GatsbyImage
                  image={countryEdgeLogo.childImageSharp.gatsbyImageData}
                  alt="Country Edge Logo"
                  className={classes.eventLogo}
                  objectFit={'contain'}
                />
              </div>
              <Card profile>
                <CardHeader image>
                  <GatsbyImage
                    image={placeholderImage.childImageSharp.gatsbyImageData}
                    className={classes.cardBackgroundImage}
                    alt="Country Edge Headliner"
                  />
                </CardHeader>
                <CardBody>
                  <h3 className={classes.cardTitle}>TBA</h3>
                  {/* <p className={classes.cardDescription}>
                    Country Music Singer & Songwriter
                  </p> */}
                  <h5 className={classes.headerIconWrapper}>
                    <RoomIcon className={classes.icons} viewBox="0 0 13 25" />
                    Country Edge Main Stage
                  </h5>
                  <h5 className={classes.headerIconWrapper}>
                    <FontAwesomeIcon
                      icon={faUserClock}
                      className={classes.icons}
                    />
                    9:30PM
                  </h5>
                  <Link to="/country-edge-lineup">
                    <Button
                      className={classes.cooksScheduleButton}
                      color="secondary"
                      size="sm"
                    >
                      Full Country Edge Lineup
                    </Button>
                  </Link>
                </CardBody>
                {/* <CardFooter className={classes.justifyContentCenter}>
                  <Button
                    href="https://x.com/dylanscottcntry"
                    justIcon
                    round
                    color="github"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 640 640"
                    >
                      <path
                        fill="rgb(255, 255, 255)"
                        d="M453.2 112L523.8 112L369.6 288.2L551 528L409 528L297.7 382.6L170.5 528L99.8 528L264.7 339.5L90.8 112L236.4 112L336.9 244.9L453.2 112zM428.4 485.8L467.5 485.8L215.1 152L173.1 152L428.4 485.8z"
                      />
                    </svg>
                  </Button>
                  <Button
                    href="https://www.instagram.com/dylanscottcountry/"
                    justIcon
                    round
                    color="instagram"
                  >
                    <FontAwesomeIcon icon={faInstagram} />
                  </Button>
                  <Button
                    href="https://www.facebook.com/dylanscottcountry/"
                    justIcon
                    round
                    color="facebook"
                  >
                    <FontAwesomeIcon icon={faFacebookSquare} />
                  </Button>
                  <Button
                    href="https://www.youtube.com/user/DylanScottCountry"
                    justIcon
                    round
                    color="youtube"
                  >
                    <FontAwesomeIcon icon={faYoutube} />
                  </Button>
                  <Button
                    href="https://dylanscottcountry.com/"
                    justIcon
                    round
                    color="google"
                  >
                    <FontAwesomeIcon icon={faExternalLinkSquareAlt} />
                  </Button>
                </CardFooter> */}
              </Card>
            </GridItem>
            <GridItem xs={12} sm={8} md={6} className={classes.headlinerItem}>
              <div className={classes.logoContainer}>
                <GatsbyImage
                  image={chilimaniaLogo.childImageSharp.gatsbyImageData}
                  alt="Chilimania Logo"
                  className={classes.eventLogo}
                  objectFit={'contain'}
                />
              </div>
              <Card profile>
                <CardHeader className={classes.cardHeaderImage} image>
                  <GatsbyImage
                    image={placeholderImage.childImageSharp.gatsbyImageData}
                    className={classes.cardBackgroundImage}
                    alt="Chilimania Headliner"
                    // imgStyle={{ objectFit: "contain" }} Just for 2024
                  />
                </CardHeader>
                <CardBody>
                  <h3 className={classes.cardTitle}>TBA</h3>
                  {/* <p className={classes.cardDescription}>
                    Def Leppard Tribute Band
                  </p> */}
                  <h5 className={classes.headerIconWrapper}>
                    <RoomIcon className={classes.icons} viewBox="0 0 13 25" />
                    105.9 THE HOG Main Stage
                  </h5>
                  <h5 className={classes.headerIconWrapper}>
                    <FontAwesomeIcon
                      icon={faUserClock}
                      className={classes.icons}
                    />
                    9:30PM
                  </h5>
                  <Link to="/chilimania-lineup">
                    <Button
                      className={classes.cooksScheduleButton}
                      color="secondary"
                      size="sm"
                    >
                      Full Chilimania Lineup
                    </Button>
                  </Link>
                </CardBody>
                {/* <CardFooter className={classes.justifyContentCenter}>
                  <Button
                    href="https://twitter.com/RealBackInBlack"
                    justIcon
                    round
                    color="github"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 640 640"
                    >
                      <path
                        fill="rgb(255, 255, 255)"
                        d="M453.2 112L523.8 112L369.6 288.2L551 528L409 528L297.7 382.6L170.5 528L99.8 528L264.7 339.5L90.8 112L236.4 112L336.9 244.9L453.2 112zM428.4 485.8L467.5 485.8L215.1 152L173.1 152L428.4 485.8z"
                      />
                    </svg>
                  </Button>
                  <Button
                    href="https://www.instagram.com/def_leggend/"
                    justIcon
                    round
                    color="instagram"
                  >
                    <FontAwesomeIcon icon={faInstagram} />
                  </Button>
                  <Button
                    href="https://www.facebook.com/DefLeggend/"
                    justIcon
                    round
                    color="facebook"
                  >
                    <FontAwesomeIcon icon={faFacebookSquare} />
                  </Button>
                  <Button
                    href="https://www.youtube.com/@defleggend9520"
                    justIcon
                    round
                    color="youtube"
                  >
                    <FontAwesomeIcon icon={faYoutube} />
                  </Button>
                  <Button
                    href="https://defleggend.com/index.html"
                    justIcon
                    round
                    color="google"
                  >
                    <FontAwesomeIcon icon={faExternalLinkSquareAlt} />
                  </Button>
                </CardFooter> */}
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    </div>
  );
}
